import React, { Component } from 'react';
import DealsToApprove from './DealsToApprove';
import EditedDealsToApprove from './EditedDealsToApprove';
import DealsStaged from './DealsStaged';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import { observer } from 'mobx-react';

const ApprovePromos = observer( class ApprovePromos extends Component {

	constructor() {
		super()

		this.state = {
			listedEvents: true,
			edited: false,
			stagedEvents: false
		}
		this.togglePage = this.togglePage.bind(this)

	}

	componentDidMount() {
		let { mainStore } = this.props.myStores;

		mainStore.getAllPreListings();
	}

	togglePage(page) {
		switch(page){
			case 'deals':
				this.setState({listedEvents:true, edited: false, staged: false})
			break;

			case 'edited':
				this.setState({listedEvents:false, edited: true, staged: false})
			break;

			case 'staged':
				this.setState({listedEvents:false, edited: false, staged: true})
			break;

			default:
				this.setState({listedEvents:true, edited: false, staged: false})
		}
	}


	render() {
		return (
			<div>
				<div style={{fontSize: 20, width: '100%'}}>
					<AppBar style={{marginTop: "15vh"}} width="inherit" color='default'>
			          <Toolbar>
			               <Typography variant='title'
			                           color='inherit'
			                           style={{
			                            fontSize: 15,
			                            marginLeft:20
			                           }}
			                           onClick={()=> this.togglePage('deals')}
			                           role='button'
			               >Submitted Events
			               </Typography>

			               <Typography variant='title'
			                           color='inherit'
			                           style={{
			                            fontSize: 15,
			                            marginLeft:20
			                           }}
			                           onClick={()=> this.togglePage('edited')}
			                           role='button'
			               >Edited Events
			               </Typography>

			               <Typography variant='title'
			                           color='inherit'
			                           style={{
			                            fontSize: 15,
			                            marginLeft:20,
			                            textDecoration: 'none'
			                           }}
			                           onClick={()=> this.togglePage('staged')}
			                           role='button'
			               >Staged Events
			               </Typography>

			            </Toolbar>
			        </AppBar>
			    </div>
			    {
			    	this.state.listedEvents ?
			    	<DealsToApprove { ...this.props } />
			    	: null
			    }
			    {
			    	this.state.edited ?
			    	<EditedDealsToApprove />
			    	: null
			    }
			    {
			    	this.state.staged ?
			    	<DealsStaged { ...this.props }/>
			    	: null
			    }
        </div>
		);
	}
})


export default ApprovePromos



// WEBPACK FOOTER //
// ./src/components/admin/ApprovePromos.js